import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, Mail } from 'lucide-react';

const Footer10 = () => {
    const navigate = useNavigate();

    const quickLinks = [
        { label: 'Home', path: '/template10' },
        { label: 'Shop', path: '/template10/shop' },
        { label: 'About', path: '/template10/about' },
        { label: 'Contact', path: '/template10/contact' },
    ];

    const supportLinks = [
        { label: 'Shipping & Returns', path: '/template10/shipping-exchange' },
        { label: 'Privacy Policy', path: '/template10/privacy-policy' },
        { label: 'Terms & Conditions', path: '/template10/terms-conditions' },
        { label: 'FAQs', path: '/template10/faqs' },
    ];

    const categoryLinks = [
        { label: 'Everyday', path: '/template10/shop' },
        { label: 'Occasion', path: '/template10/shop' },
        { label: 'Heritage', path: '/template10/shop' },
        { label: 'All Products', path: '/template10/shop' },
    ];

    return (
        <>
            <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap" rel="stylesheet" />

            <footer
                className="bg-white"
                style={{
                    fontFamily: "'Inter', sans-serif",
                    borderTop: '1px solid #E7E5E4',
                }}
            >
                <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-12 md:py-16">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
                        {/* Brand */}
                        <div className="col-span-2 md:col-span-1">
                            <h3
                                className="text-base font-light tracking-[3px] text-[#1C1917] uppercase mb-4"
                            >
                                STHIR
                            </h3>
                            <p className="text-[#78716C] text-xs font-light leading-relaxed mb-6 max-w-[200px]">
                                Curated Indian fashion rooted in simplicity and mindful design.
                            </p>
                            <div className="flex items-center gap-4">
                                <a href="#" className="text-[#78716C] hover:text-[#1C1917] transition-colors duration-300">
                                    <Instagram size={16} strokeWidth={1.5} />
                                </a>
                                <a href="#" className="text-[#78716C] hover:text-[#1C1917] transition-colors duration-300">
                                    <Mail size={16} strokeWidth={1.5} />
                                </a>
                            </div>
                        </div>

                        {/* Quick Links */}
                        <div>
                            <h4 className="text-[11px] font-normal tracking-[2px] text-[#78716C] uppercase mb-4">
                                Navigate
                            </h4>
                            <ul className="space-y-3">
                                {quickLinks.map((link) => (
                                    <li key={link.label}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            className="text-xs font-light text-[#78716C] hover:text-[#1C1917] cursor-pointer transition-colors duration-300"
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Categories */}
                        <div>
                            <h4 className="text-[11px] font-normal tracking-[2px] text-[#78716C] uppercase mb-4">
                                Collections
                            </h4>
                            <ul className="space-y-3">
                                {categoryLinks.map((link) => (
                                    <li key={link.label}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            className="text-xs font-light text-[#78716C] hover:text-[#1C1917] cursor-pointer transition-colors duration-300"
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Support */}
                        <div>
                            <h4 className="text-[11px] font-normal tracking-[2px] text-[#78716C] uppercase mb-4">
                                Support
                            </h4>
                            <ul className="space-y-3">
                                {supportLinks.map((link) => (
                                    <li key={link.label}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            className="text-xs font-light text-[#78716C] hover:text-[#1C1917] cursor-pointer transition-colors duration-300"
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    {/* Bottom Bar */}
                    <div className="mt-12 pt-6" style={{ borderTop: '1px solid #E7E5E4' }}>
                        <p className="text-center text-[#A8A29E] text-[11px] font-light tracking-wider">
                            &copy; 2026 STHIR. All rights reserved.
                        </p>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer10;
